import React from 'react'
import { useEffect, useState } from 'react';
import { Footer } from '../../../common/footer/footer';

import Sidebar from "../sidebar/sidebar.js";
import { Pagination } from '../../../common/pagination/uiPagination';
import { convertToCanadianDateTime } from '../../../../shared/helper';

export const CustomerAskTheExpertJsx = (props) => {
  const {
    customerQueryData,page,onPaginationButtonClick
    // meta
  } = props;

  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, [])

  const itemsPerPage = 10

  const [currentPage] = useState(1);
  const currentItems = customerQueryData?.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );


  // {t("PRINT.TITLE")}
  return (
    <>
      <section className="entiredashboard admindashboard">
        <div className="container">

          <div className="row">
            <div className="col-lg-3 col-sm-3">


              <div className="dashboardleftpanel martop40">

                <div className="dashboardlink martop40">
                  <Sidebar />
                </div>
              </div>
            </div>
            <div className="col-lg-9 col-sm-9">
              <div className="dashboardrightpanel martop40">
                <h2 className="h2_style">Customer Query</h2>


                
              </div>

              <div className="expertsection martop30 mb-5">
                <div className="searchdetails searchdetalsen">
                  <table className="searchdetailsdb">
                    <tr>
                      <th>Customer ID</th>
                      <th>Name</th>
                      <th>Email</th>

                      <th>Phone</th>
                      <th>Address</th>
                     



                      <th>Query</th>
                      <th>Created ad</th>
                      {/* <th>Action</th> */}
                    </tr>

                    {currentItems?.map((item, i) => (
                      <>
                        <tr>
                          <td>{item?.customer?.customerId}</td>
                          <td>{item.customer.firstName} {item.customer.lastName}</td>
                          
                          <td>{item.customer.email}</td>
                          <td>{item.customer.phoneNumber}</td>
                          <td>{item.customer.address}, {item.customer.city}, {item.customer.postalCode}</td>
                        


                          <td>{item.query}</td>
                          <td>{convertToCanadianDateTime(item.createdAt)}</td>
                          {/* <td>
                          <button className="btn btn-success" onClick={() => editCategory(item?.institutionCategoryId)}>Edit</button>
                                  <button className="btn btn-danger"  onClick={() => deleteOffer(item?.institutionCategoryId)} >delete</button></td> */}
                          
                        </tr>
                      </>
                    ))}

                  </table>
                  {currentItems?.length > 0 && <section className="newpagination" > <Pagination
              currentPage={currentPage}
              page={page}
              itemsPerPage={itemsPerPage}
              allOffersData={customerQueryData}
              currentItems={currentItems}
              onPaginationButtonClick={onPaginationButtonClick}

            /></section>}
                </div>
              </div>


            </div>

          </div>

        </div>
      </section>

      <Footer />
    </>

  );
};

export default CustomerAskTheExpertJsx;